import { inject } from '@angular/core'
import { CanDeactivateFn } from '@angular/router'

import { StepModeFacadeService } from './step-mode-facade.service'

export const stepModeLeaveGuard: CanDeactivateFn<unknown> = () => {
  const facade = inject(StepModeFacadeService)
  const step = facade.currentStep()

  if (step?.step_type !== 'ai' || !facade.isAgentStreaming()) {
    return true
  }

  return window.confirm(
    'AI is still generating. Leaving this page will restart the step and the current response will be lost. Continue?'
  )
}
